import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });
export const clientApi = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const imgUrl = (u) => (!u ? "" : u.startsWith("/api/") ? `${BACKEND}${u}` : u);

// Foto private: l'autorizzazione viaggia nel cookie HttpOnly dell'area clienti, mai nell'URL.
export const clientImg = imgUrl;

export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 2 }).format(n || 0);

export const fmtDate = (d, opts = { day: "numeric", month: "long", year: "numeric" }) => {
  if (!d) return "";
  const dt = new Date(d.length === 10 ? `${d}T12:00:00` : d);
  return isNaN(dt) ? d : dt.toLocaleDateString("it-IT", opts);
};

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Qualcosa è andato storto. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const EVENT_TYPES = [
  { value: "matrimonio", label: "Matrimonio", plural: "Matrimoni", slug: "matrimoni" },
  { value: "cerimonia", label: "Cerimonia", plural: "Cerimonie", slug: "cerimonie", hidden: true },
  { value: "newborn", label: "Newborn", plural: "Newborn", slug: "newborn" },
  { value: "maternita", label: "Maternità", plural: "Maternità", slug: "maternita" },
  { value: "battesimo", label: "Battesimo", plural: "Battesimi", slug: "battesimi" },
  { value: "diciottesimo", label: "Diciottesimo", plural: "Diciottesimi", slug: "diciottesimi" },
  { value: "compleanno", label: "Compleanno", plural: "Compleanni", slug: "compleanni" },
];
export const STUDIO = { brand: "Santarelli Studio", name: "Studio Fotografico Santarelli", street: "SP 17 61, Sassa Scalo", city: "67100 L'Aquila", email: "info@santarellifotografi.com", vat: "01934100668", phone: "+39 328 597 9670" };
export const WHATSAPP = "https://wa.me/393285979670?text=Buongiorno%20Studio%20Santarelli%2C%20vorrei%20richiedere%20un%20preventivo.";
export const PUBLIC_TYPES = EVENT_TYPES.filter((t) => !t.hidden);
export const typeLabel = (v) => EVENT_TYPES.find((t) => t.value === v)?.label || v;

export const STEPS = ["Confermato", "Acconto versato", "Servizio fotografico", "Selezione foto", "Post-produzione", "Bozza album", "Consegnato"];

export const LEAD_STATUSES = [
  { value: "nuovo", label: "Nuovo", cls: "bg-amber-50 text-amber-800" },
  { value: "contattato", label: "Contattato", cls: "bg-sky-50 text-sky-800" },
  { value: "preventivo", label: "Preventivo creato", cls: "bg-emerald-50 text-emerald-800" },
  { value: "chiuso", label: "Chiuso", cls: "bg-slate-100 text-slate-500" },
];

export const SOCIAL = {
  instagram: "https://www.instagram.com/santarelli_fotografi/",
  facebook: "https://www.facebook.com/StudioFotograficoSantarelli/?locale=it_IT",
};

export const CONTRACT_STATUSES = [
  { value: "da_preparare", label: "Da preparare" },
  { value: "inviato", label: "Inviato al cliente" },
  { value: "firmato", label: "Firmato" },
];
export const ALBUM_STATUSES = [
  { value: "in_lavorazione", label: "Fotografie in lavorazione" },
  { value: "selezione", label: "In attesa della vostra selezione" },
  { value: "impaginazione", label: "Album in preparazione" },
  { value: "stampa", label: "In stampa" },
  { value: "pronto", label: "Pronto per il ritiro" },
  { value: "consegnato", label: "Consegnato" },
];
export const STATUS_OPTS = { story: [{ value: "bozza", label: "Bozza" }, { value: "pubblicata", label: "Pubblicata" }, { value: "archiviata", label: "Archiviata" }],
  review: [{ value: "in_attesa", label: "In attesa di approvazione" }, { value: "bozza", label: "Bozza" }, { value: "pubblicata", label: "Pubblicata" }, { value: "nascosta", label: "Nascosta" }],
  service: [{ value: "bozza", label: "Bozza" }, { value: "pubblicata", label: "Pubblicata" }] };
export const labelOf = (list, v) => list.find((x) => x.value === v)?.label || v || "—";
export const allPhotos = (g) => (g?.chapters || []).flatMap((c) => c.photos);
export const ROMAN = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];
